import { call, put, select } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import { get } from 'lodash';

import { SHOW_RESET_DIALOG, SHOW_TWO_FACTOR_FORM, HIDE_TWO_FACTOR_FORM } from 'containers/LoginPage/constants';
import { SIGN_IN } from '@lib/actions/actionTypes';
import authResource from 'resources/authResource';
import { selectCurrentUser } from '@lib/selectors';
import { initApp } from '@lib/actions';
import sagaFetch from './sagaFetch';

// bind resource generators
const signIn = sagaFetch.bind(null, SIGN_IN, authResource.signIn);
const signInSubaccount = sagaFetch.bind(null, SIGN_IN, authResource.signInSubaccount);

export default function* sagaSignIn(action) {
  const { credentials, subaccountId, returnUrl, isZendeskLogin } = action;
  if (subaccountId) {
    // sign in from subaccount
    const response = yield call(signInSubaccount, { id: subaccountId });
    if (get(response, 'error', false)) {
      return;
    }
  } else {
    // sign in using credentials
    const response = yield call(signIn, { credentials });
    const error = get(response, 'error', false);

    if (error) {
      // 2FA
      // TODO: normalize
      if (error.show2FA) {
        yield put({ type: SHOW_TWO_FACTOR_FORM });
      }
      // password expired
      // TODO: normalize
      if (error.passwordExpired) {
        yield put({ type: SHOW_RESET_DIALOG });
      }
      return;
    }
    yield put({ type: HIDE_TWO_FACTOR_FORM });
  }

  if (isZendeskLogin) {
    const { email, firstname, lastname } = yield select(selectCurrentUser);
    const user = {
      email,
      name: `${firstname} ${lastname}`,
    };
    authResource.zendeskSSO(user);
  } else {
    yield put(
      initApp.request({
        meta: {
          callbackSuccess: () => browserHistory.push(returnUrl),
        },
      }),
    );
  }
}
